import { useAuth0 } from "@auth0/auth0-react";
import MenuIcon from "@mui/icons-material/Menu";
import { Box, Drawer, IconButton } from "@mui/material";
import { useIsDarkMode } from "../hook/setting";
import {
  useInitSideNavOpenListener,
  useSideNavOpen,
  useToggleSideNavOpen,
} from "../hook/sideNav";
import { ListSmall } from "./sideNav/listItem";
import { NotebookExplorer } from "./sideNav/notebookExplorer";
import { SideNavMarketplace } from "./sideNav/marketplace";
import { SideNavChat } from "./sideNav/chat";
import { WorkspaceSwitcher } from "./sideNav/workspaceSwitcher";

export const ToggleSideNavButton: React.FC = () => {
  const toggleSideNavOpen = useToggleSideNavOpen();
  return (
    <Box p={2}>
      <IconButton
        color="primary"
        aria-label="toggle drawer"
        onClick={() => toggleSideNavOpen()}
      >
        <MenuIcon />
      </IconButton>
    </Box>
  );
};

// The side nav's contents, shared by the desktop drawer and the Phone Shell's Browse view.
export const SideNavContents: React.FC = () => (
  <>
    <WorkspaceSwitcher />
    <ListSmall>
      <SideNavChat />
      <SideNavMarketplace />
      <NotebookExplorer />
    </ListSmall>
  </>
);

export const SideNavLoggedIn: React.FC<{ drawerWidth: string }> = ({
  drawerWidth,
}) => {
  const { sideNavOpen } = useSideNavOpen();
  const { isDarkMode } = useIsDarkMode();

  return (
    <Drawer
      variant="persistent"
      open={sideNavOpen}
      sx={{
        width: sideNavOpen ? drawerWidth : "0",
        "& .MuiDrawer-paper": {
          width: sideNavOpen ? drawerWidth : "0",
          boxSizing: "border-box",
          backgroundColor: (theme) =>
            isDarkMode
              ? theme.palette.background.default
              : theme.palette.background.paper,
        },
      }}
    >
      {sideNavOpen && <ToggleSideNavButton />}
      {sideNavOpen && <SideNavContents />}
    </Drawer>
  );
};

export const SideNav: React.FC<{ drawerWidth: string }> = ({ drawerWidth }) => {
  const { isAuthenticated } = useAuth0();
  useInitSideNavOpenListener();

  return isAuthenticated ? (
    <SideNavLoggedIn drawerWidth={drawerWidth} />
  ) : (
    <></>
  );
};
